var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.trade-st0{fill:#CCCCCC;}\n\t.trade-st1{fill:#F2F2F2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "trade-st0",
    d: "M232.4,440.5c-42.8,0-77.7-34.9-77.7-77.7V238c0-42.8,34.9-77.7,77.7-77.7h124.8c42.8,0,77.7,34.9,77.7,77.7 v124.8c0,42.8-34.9,77.7-77.7,77.7H232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trade-st1",
    d: "M357.2,171.8c36.5,0,66.2,29.7,66.2,66.2v124.8c0,36.5-29.7,66.2-66.2,66.2H232.4 c-36.5,0-66.2-29.7-66.2-66.2V238c0-36.5,29.7-66.2,66.2-66.2H357.2 M357.2,148.9H232.4c-49.2,0-89.2,39.9-89.2,89.2v124.8 c0,49.2,39.9,89.2,89.2,89.2h124.8c49.2,0,89.2-39.9,89.2-89.2V238C446.3,188.8,406.4,148.9,357.2,148.9L357.2,148.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "trade-st0",
    d: "M155.8,351.7c-42.8,0-77.7-34.9-77.7-77.7V149.2c0-42.8,34.9-77.7,77.7-77.7h124.8 c42.8,0,77.7,34.9,77.7,77.7V274c0,42.8-34.9,77.7-77.7,77.7H155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trade-st1",
    d: "M280.6,82.9c36.5,0,66.2,29.7,66.2,66.2V274c0,36.5-29.7,66.2-66.2,66.2H155.8c-36.5,0-66.2-29.7-66.2-66.2 V149.2c0-36.5,29.7-66.2,66.2-66.2H280.6 M280.6,60H155.8c-49.2,0-89.2,39.9-89.2,89.2V274c0,49.2,39.9,89.2,89.2,89.2h124.8 c49.2,0,89.2-39.9,89.2-89.2V149.2C369.8,99.9,329.9,60,280.6,60L280.6,60z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.92d6996f.svg";
export { ForwardRef as ReactComponent };